<template>
  <v-card class="card-border">
    <v-card-text>
      <v-data-table ref="dataTable" :headers="headers" :items="getDataTable" :search="search">
        <template v-slot:top>
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="search" label="Procurar..." prepend-inner-icon="mdi-magnify" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.action="{ item, index }">
          <v-tooltip v-if="$ability.can('Editar','Adimplencia')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogFormAdimplencia.show(true, item)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            Editar
          </v-tooltip>
          <v-tooltip v-if="$ability.can('Deletar','Adimplencia')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="deleteFaixaAdimplencia(item, index)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            Deletar
          </v-tooltip>
        </template>
      </v-data-table>
      <DialogFormAdimplencia @updated="update($event)" ref="dialogFormAdimplencia" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Adimplencia from "@/services/adimplencia";
export default {
  name: "TableAdimplencia",

  components: {
    DialogFormAdimplencia: () => import("./DialogFormAdimplencia.vue")
  },

  data() {
    return {
      headers: [
        { text: "Parâmetro", value: "apelido" },
        { text: "Papel", value: "papel" },
        { text: "Faixa 1", value: "faixaAdimplencia1" },
        { text: "Faixa 2", value: "faixaAdimplencia2" },
        { text: "Ações", value: "action", sortable: false, align: "center" }
      ],
      search: "",
      serviceAdimplencia: new Adimplencia()
    };
  },

  computed: {
    ...mapGetters("adimplencia", ["getAdimplencia"]),

    getDataTable() {
      return this.getAdimplencia || [];
    }
  },

  methods: {
    update(newAdimplencia) {
      let index = this.$refs.dataTable.items.findIndex(
        item => item.id === newAdimplencia[1]
      );
      this.$refs.dataTable.items[index].papel = newAdimplencia[0].papel;
      this.$refs.dataTable.items[index].faixaAdimplencia1 =
        newAdimplencia[0].faixaAdimplencia1;
      this.$refs.dataTable.items[index].faixaAdimplencia2 =
        newAdimplencia[0].faixaAdimplencia2;
    },

    async deleteFaixaAdimplencia(item, index) {
      try {
        await this.serviceAdimplencia.delete(item.id);
        this.$toast.success(`Faixa de adimpência deletada com sucesso.`);
        this.$refs.dataTable.items.splice(index, 1);
      } catch (error) {
        this.$toast.error(error);
        console.error(error);
      }
    }
  }
};
</script>

<style></style>
